import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ee8962"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Asset name")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Category")
], -1))
const _hoisted_3 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.assetRef,
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        name: "name"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_a_input, {
            type: "text",
            value: _ctx.assetRef.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.assetRef.name) = $event)),
            placeholder: "Asset name",
            class: "ant-input"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { name: "category" }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_a_select, {
            class: "custom-input-style",
            placeholder: "Please select",
            style: {"width":"100%"},
            value: _ctx.assetRef.category,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.assetRef.category) = $event)),
            onChange: _ctx.handleChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
                return (_openBlock(), _createBlock(_component_a_select_option, { key: index }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(category), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { name: "upload" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_upload, {
            "list-type": "picture",
            "preview-file": _ctx.previewFile,
            multiple: false,
            class: "upload-style",
            customRequest: _ctx.customRequest
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, null, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "upload",
                    style: {"margin-right":"10px"}
                  }),
                  _createTextVNode(" Upload File ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["preview-file", "customRequest"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              disabled: _ctx.loading,
              style: {"margin-right":"10px"},
              type: "default",
              onClick: _ctx.onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_a_button, {
              loading: _ctx.loading,
              disabled: _ctx.loading,
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}